import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import TanomuCsvImportLayout from 'components/organismos/master/sales/TanomuCsvImportLayout/TanomuCsvImportLayout';

const TanomuCsvImportPage = () => (
  <SidebarTemplate pageTitle="TANOMU連携">
    <TanomuCsvImportLayout />
  </SidebarTemplate>
);

export default TanomuCsvImportPage;
